export default {
  actions: {
    activateCadasterLayer: 'Visualizar capa catastral',
    minimize: 'Minimiza',
    maximize: 'Maximiza',
    openNewTab: 'Abrir en una nueva pestaña'
  },
  names: {
    image: 'Imagen',
    keywords: 'Búsquedas relacionadas',
    lateral: 'Lateral',
    map: 'Mapa',
    next: 'Seguiente',
    panorama: 'Panorama',
    pointCloud: 'Nube de puntos',
    previous: 'Anterior',
    projection: 'Proyección',
    tools: 'Herramientas',
    home: 'Inicio',
    baseMap: 'Mapa base',
    moveForward: 'Avanzar',
    moveBackwards: 'Retroceder'
  },
  messages: {
    referenceNotFound: 'No se ha encontrado la referencia',
    browserPopupBlocked: 'El navegador ha bloqueado la ventana emergente. Permite las ventanas emergentes para este sitio para sincronizar las sesiones de administración y geoportal.'
  },
  tools: {
    auth: {
      sessionNotStarted: 'No se ha iniciado ninguna sesión.',
      loggedToMapia: 'La sesión de Mapia se ha iniciado correctamente'
    },
    downloads: {
      headerName: 'Descargas',
      title: 'Centro de descargas'
    },
    language: {
      headerName: 'Idioma'
    },
    opendata: {
      headerName: 'Open Data'
    },
    geovideos: {
      headerName: 'Geovideo',
      description: 'No se ha encontrado ningún vídeo en este punto.',
      activateCenterMap: 'Centrar mapa',
      deactivateCenterMap: 'Desactivar centrar mapa',
      clickMapDescription: 'Haz clic sobre el mapa para acceder a los vídeos georeferenciados.',
      additionalInfo: 'Información adicional',
      showAdditionalInfo: 'Mostrar información adicional',
      second: 'Segundo',
      stepForwardBackward: 'Recorrer distancia (m)',
      takePicture: 'Capturar vista actual',
      reproductionSpeed: 'Velocidad de reproducción'
    },
    panorama: {
      addAmbit: 'Capa de ámbitos',
      addAmbitCaption: 'Añade una capa con los ámbitos en los que hay panoramas',
      addLayer: 'Capa panoramas',
      addLayerCaption: 'Añaden una capa con los puntos donde hay panormas',
      headerName: 'Entorno 3D',
      title: 'Fotografías panorámicas y nubes de puntos',
      help: 'Haz click sobre el mapa para acceder a la fotografía panorámica y las nubes de puntos obtenidas mediante Mobile Mapping.',
      centerMap: 'Centrar mapa',
      noDataError: 'No se han encontrado datos en esta localización.',
      disablePano: 'Desactiva panorama',
      enablePano: 'Activa panorama',
      enablePanoDescription: 'Activa/desactiva el visor de panoramas',
      enableLateral: 'Activa imagen lateral',
      disable3D: 'Desactiva 3D',
      enable3D: 'Activa 3D',
      enable3DDescription: 'Activa/desactiva el visor de núbes de puntos',
      unsync3D: 'Desincroniza 3D',
      sync3D: 'Sincroniza 3D',
      openPano: 'Abre panorama',
      openPanoCaption: 'Abre el panorama en otra ventana',
      openPointCloud: 'Abre nube de puntos',
      openPointCloudCaption: 'Abre la nube de puntos en otra ventana',
      rotateLeft: 'Gira el panorama 90º a la izquierdas',
      rotate180: 'Gira el panorama 180º',
      rotateRight: 'Gira el panorama 90º a la derecha',
      mustLogin: 'Inicia sesión para visualizar los panoramas',
      infoCampaign: 'Información campaña activa',
      descriptionCampaign: 'Descripción campaña',
      zoneCampaign: 'Zona',
      dateCampaign: 'Fechas campaña',
      startCampaign: 'Inici campaña',
      endCampaign: 'Final campaña',
      splitVertially: 'Divide verticalmente',
      splitHorizontaly: 'Divide horizontalmente',
      drawingNavigationPanel: 'Navegación automática',
      drawingNavigationPanelDescription: 'Abre la ventana de navegación automática',
      generateNewRoute: 'Generar nuevo recorrido',
      playlist: 'Lista de reproducción',
      reversePlaylist: 'Invertir sentido del recorrido',
      removePlaylist: 'Borrar el recorrido',
      drawingNavigationPanelInfo: 'Dibuja una línea para generar el recorrido por el que quieres navegar. Haz doble clic para dejar de dibujar.',
      drawingNavigationPanelInfo2: 'Haz clic en "Generar nuevo recorrido" para dibujar sobre el mapa el recorrido por el que quieres navegar.',
      drawingNavigationPanelInfo3: 'Haz clic en el botón de "Play" para iniciar el recorrido.',
      playPlaylist: 'Navega por el recorrido',
      stopPlaying: 'Detener reproducción',
      timePerPoint: 'Tiempo por punto en segundos',
      stepBetweenPoints: 'Salto entre puntos'
    },
    addCustomLayer: {
      headerName: 'Añadir capa',
      title: 'Añadir capa personalizada',
      layerFormat: 'Escoge formato nueva capa',
      layerFormatOptions: [
        'WMS',
        'TMS',
        'GeoJSON',
        'GML'
      ],
      layerName: 'Escribe el nombre de la capa',
      layerURL: 'Escribe la URL de la capa o servicio',
      properties: 'Propiedades',
      layerWMSLayers: 'Indica las capas del WMS: capa1, capa2, ...',
      layerWMSLayersHint: 'Utiliza la coma para separar cada capa.',
      layerProjection: 'Proyección:',
      layerWMSSingleImage: 'Cargar WMS sin teselar, utilizando una sola imagen',
      layerTMSInvert: 'Invertir las teselas en el eje de les Y',
      geojsonColor: 'Selecciona color línea',
      geojsonFillColor: 'Selecciona color relleno',
      geojsonWeight: 'Grosor',
      geojsonWeightHint: 'Solo números',
      geojsonOpacity: 'Opacidad',
      geojsonOpacityHint: 'Solo números del 0 al 1',
      addButton: 'Añadir capa al mapa'
    },
    search: {
      advanced: {
        title: 'Búsqueda avanzada',
        optionsLabel: 'Selecciona qué quieres buscar',
        layers: 'Capas del catálogo',
        address: 'Dirección',
        addressICGC: 'Dirección (ICGC)',
        municipality: 'Municipio (opcional)',
        refcad: 'Referencia catastral',
        coordinates: 'Coordenadas',
        pkFerroviariICGC: 'Punto quilométrico ferroviario (ICGC)',
        pkICGC: 'Punto quilométrico (ICGC)',
        layerSearchLabel: 'Nombre de la capa',
        search: 'Búsqueda',
        roadSearchLabel: 'Vía (Ex: AP-7)',
        pkSearchLabel: 'Punto quilométrico (Ex: 123)',
        epsgLabel: 'SRS',
        latitude: 'Latitud',
        longitude: 'Longitud',
        x: 'X',
        y: 'Y',
        street: 'Calle',
        streetNumber: 'Número'
      }
    },
    panoramasIncidence: {
      requiredField: 'Campo obligatorio',
      descriptionMissing: 'El tipus de incidencia "Otros" requiere una descripción',
      notifyIncidence: 'Notifica incidencia',
      incidenceType: 'Tipo de incidencia',
      incidenceOptions: [
        'Información sensible sin ofuscar',
        'Error en la imagen panorámica',
        'Error en la nube de puntos',
        'Orientación panorama/nube de puntos no coincideix',
        'Otros'
      ]
    }
  }
}
